export const cacheResponse = async (redisClient, key, callback, duration = null) => {
  try {
    if (redisClient) {
      const data = await redisClient.get(key);
      if (data) {
        return Promise.resolve(data);
      }
    }
    const res = await callback;
    if (redisClient) {
      await redisClient.set(key, res, duration);
    }
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
}